export const CSavingsGoalDetails = {
    TEEN_ID: 'teenId',
    GOAL_ID: 'goalId'
} as const;

export const COrderTransaction = {
    DESC: 'desc',
    ASC: 'asc'
} as const

export const CDefaultRangeLastTransactions = {
    START_INDEX_TRANSACTION_LIST: 0,
    END_INDEX_TRANSACTION_LIST: 3
}

export const CKeyTransactionsToOrder = {
    TRANSACTION_DATE: "transaction_date"
}